module.exports = "p{\r\n    font-weight: bold;\r\n    font-size: 50px;\r\n    text-align: center;\r\n    color: #c72d2d;\r\n}"